import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PosterPreview from "./PosterPreview";
import Button from "react-bootstrap/Button";
import useLocalStorage from "./hooks/useLocalStorage";
import PosterGallery from "./PosterGallery";
import AlertDismissible from "./AlertDismissible";

const sortPostersByTitleAZ = (a, b) => {
  let nameA = a.title.toUpperCase();
  let nameB = b.title.toUpperCase();
  if (nameA < nameB) {
    return -1;
  } else if (nameA > nameB) {
    return 1;
  } else {
    return 0;
  }
};

const sortPostersByTitleZA = (b, a) => {
  let nameA = a.title.toUpperCase();
  let nameB = b.title.toUpperCase();
  if (nameA < nameB) {
    return -1;
  } else if (nameA > nameB) {
    return 1;
  } else {
    return 0;
  }
};

const sortPostersByIdAsc = (a, b) => {
  let orderA = a.order;
  let orderB = b.order;
  if (orderA < orderB) {
    return -1;
  } else if (orderA > orderB) {
    return 1;
  } else {
    return 0;
  }
};

const sortPostersByIdDesc = (b, a) => {
  let orderA = a.order;
  let orderB = b.order;
  if (orderA < orderB) {
    return -1;
  } else if (orderA > orderB) {
    return 1;
  } else {
    return 0;
  }
};
const getSortFunction = (sortType) => {
  switch (sortType) {
    case "titleAZ":
      return sortPostersByTitleAZ;
    case "titleZA":
      return sortPostersByTitleZA;
    case "numberAsc":
      return sortPostersByIdAsc;
    case "numberDesc":
      return sortPostersByIdDesc;
    default:
      return sortPostersByTitleAZ;
  }
};
const AllPosters = ({ onPosterClick, config }) => {
  const { sessionId } = useParams();
  const [showInstructions, setShowInstructions] = useLocalStorage(
    "posters-instructions",
    true
  );
  const session = Object.values(config.themes).find(
    (session) => session.id === sessionId
  );

  return (
    <div className="poster-session">
      <Button className="back-button" href="/">
        <i className="fas fa-arrow-left" />
      </Button>
      <h1>{session.title}</h1>
      {showInstructions && config.instructions && (
        <AlertDismissible
          show={showInstructions}
          config={config.instructions}
          setShowInstructions={setShowInstructions}
        />
      )}
      <div className="session-posters wrap">
        {Object.values(session.posters)
          .sort(getSortFunction(config.postersDisplayOrder))
          .map((poster, idx) => (
            <div className="flex-item" key={poster.id}>
              <PosterPreview
                poster={poster}
                onClick={() => onPosterClick(idx)}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

const PosterSession = ({ config }) => {
  const [currentPoster, setCurrentPoster] = useState(-1);
  const { sessionId, posterId } = useParams();

  useEffect(() => {
    if (!config.themes) {
      return;
    }
    const session = Object.values(config.themes).find(
      (session) => session.id === sessionId
    );
    const posterNumber = Object.values(session.posters)
      .sort(getSortFunction(config.postersDisplayOrder))
      .findIndex((poster) => poster.id === posterId);

    setCurrentPoster(posterNumber);
  }, [config.themes, posterId, sessionId, config.postersDisplayOrder]);

  if (!config.themes) return <span />;
  const session = Object.values(config.themes).find(
    (session) => session.id === sessionId
  );
  if (currentPoster === -1)
    return (
      <AllPosters
        config={config}
        onPosterClick={(posterId) => setCurrentPoster(posterId)}
      />
    );

  const poster = Object.values(session.posters).sort(
    getSortFunction(config.postersDisplayOrder)
  )[currentPoster];

  return (
    <div className="poster-session">
      <Button className="back-button" onClick={() => setCurrentPoster(-1)}>
        <i className="fas fa-arrow-left" />
      </Button>
      <div className="title-with-buttons">
        <h2 className="poster-title">{poster.title}</h2>
        <p>{poster.authors}</p>
        {poster.contactDetails && (
          <div className="contact-details">
            {poster.contactDetails.fullName && (
              <div className="contact-details-item">{`Contact: ${poster.contactDetails.fullName}`}</div>
            )}
            {poster.contactDetails.email && (
              <div className="contact-details-item">
                Email:{" "}
                <a href={`mailto:${poster.contactDetails.email}`}>
                  {poster.contactDetails.email}
                </a>{" "}
              </div>
            )}
            {poster.contactDetails.skype && (
              <div className="contact-details-item">{`Skype: ${poster.contactDetails.skype}`}</div>
            )}
          </div>
        )}
        <div style={{ padding: "1rem" }}>
          <Button
            variant={currentPoster === 0 ? "dark" : "primary"}
            disabled={currentPoster === 0}
            onClick={() => setCurrentPoster((current) => current - 1)}
          >
            Previous abstract
          </Button>
          <Button
            variant={
              currentPoster === Object.keys(session.posters).length - 1
                ? "dark"
                : "primary"
            }
            disabled={currentPoster === Object.keys(session.posters).length - 1}
            onClick={() => setCurrentPoster((current) => current + 1)}
          >
            Next abstract
          </Button>
        </div>
      </div>
      <div className="poster-with-buttons">
        <PosterGallery session={session.id} poster={poster} />
      </div>
    </div>
  );
};

export default PosterSession;
